module.exports = __webpack_public_path__ + "img/svg - only background.aaeb6638.svg";